<template>


  <ModalContainer queryParam="forms" ref="modalContainer" size="lg">
    <b-overlay :show="busy">
      <template #overlay>
        <div v-if="processing" class="text-center p-4 bg-light text-dark rounded">
          <b-icon icon="cloud-download" animation="cylon-vertical" font-scale="4"></b-icon>
          <div class="my-2">Descargando...</div>
          <b-progress min="1" max="20" :value="counter" variant="success" height="3px"
            class="mx-n4 rounded-0"></b-progress>
        </div>

        <div v-if="cargandoFormularios" class="text-center p-4 bg-light text-dark rounded">
          <b-icon icon="clock" animation="spin-reverse-pulse" font-scale="4"></b-icon>
          <div class="my-2">Cargando...</div>

        </div>


      </template>

      <b-alert show variant="warning" class="p-2">
        <b-row class="my-1">
          <b-col>Paciente: <label>{{ dataProc.paciente }}</label> </b-col>
          <b-col>Procedimiento: <label>{{ dataProc.procedimiento }}</label> </b-col>

        </b-row>
        <b-row>
          <b-col>Fecha programada: <label>{{ dataProc.fechaProgramada }}</label> </b-col>
          <b-col>Estado: <label>{{ dataProc.estado }}</label> </b-col>


        </b-row>
      </b-alert>


      <b-card>


        <div class="row align-items-center mb-3 justify-content-between mx-2">
          <h3 class="modal-title">Formularios</h3>
          <b-button @click="descargarZipInformes" variant="secondary"> <i
              class="fa-solid fa-file-zipper font-weight-lighter"></i> Descargar Todos</b-button>
        </div>

        <div>
          <!-- <b-button 
          v-if="data.item.estadoProceso === 'Resultado'" 
          variant="primary" size="sm"
          @click="procedimientoMedicamento(data.item.id)">
          <i class="fas fa-capsules" style="color: white" />
        </b-button> -->

          <div class="row ml-2 mb-2 align-items-center">

            <span class="col-6">003 - Hospitalizacion</span>

            <b-button v-if="canViewBtn(codigoProceso, '003')" id="boton-modal003"
              :variant="idsFormsExistentes.includes('003') ? 'success' : 'primary'" size="sm" @click="showModal003"
              title="Formulario 003">
              {{ idsFormsExistentes.includes('003') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('003')" variant="warning" size="sm" class="ml-2"
              @click="generar003">
              Descargar
            </b-button>
          </div>



          <div class="row ml-2 mb-2 align-items-center">

            <span class="col-6">005 - Evolucion y Prescripciones</span>



            <b-button v-if="canViewBtn(codigoProceso, '005')" id="boton-modal005"
              :variant="idsFormsExistentes.includes('005') ? 'success' : 'primary'" size="sm" @click="showModalForm005"
              title="Formulario 005">
              {{ idsFormsExistentes.includes('005') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('005')" variant="warning" size="sm" class="ml-2"
              @click="generar005">
              Descargar
            </b-button>
          </div>

          <div class="row ml-2 mb-2 align-items-center">

            <span class="col-6">006 - Epicrisis</span>

            <b-button v-if="canViewBtn(codigoProceso, '006')" id="boton-modal006"
              :variant="idsFormsExistentes.includes('006') ? 'success' : 'primary'" size="sm" @click="showModalForm006"
              title="006 - Epicrisis">
              {{ idsFormsExistentes.includes('006') ? 'Actualizar' : 'Procesar' }}

            </b-button>



            <b-button v-if="idsFormsExistentes.includes('006')" variant="warning" size="sm" class="ml-2"
              @click="generar006">
              Descargar
            </b-button>
          </div>


          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">012B - Formulario Colcoscopia</span>

            <b-button v-if="canViewBtn(codigoProceso, '12b')" id="boton-modal012B"
              :variant="idsFormsExistentes.includes('12b') ? 'success' : 'primary'" size="sm" @click="modalForm012B"
              title="Formulario Colcoscopia">
              {{ idsFormsExistentes.includes('12b') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('12b')" variant="warning" size="sm" class="ml-2"
              @click="generar12b">
              Descargar
            </b-button>
          </div>

          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">012B Formulario</span>

            <b-button v-if="canViewBtn(codigoProceso, '12bNormal')" id="boton-modal012BNormal"
              :variant="idsFormsExistentes.includes('12bNormal') ? 'success' : 'primary'" size="sm"
              @click="modalForm012BNormal" title="Formulario Colcoscopia">
              {{ idsFormsExistentes.includes('12bNormal') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('12bNormal')" variant="warning" size="sm" class="ml-2"
              @click="generar12bNormal">
              Descargar
            </b-button>
          </div>
          <!-- 

          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">013 - Solicitud Anatomia Patologica</span>

            <b-button v-if="canViewBtn(codigoProceso, '13a')" id="boton-modal013"
              :variant="idsFormsExistentes.includes('13a') ? 'success' : 'primary'" size="sm" @click="showModal13a"
              title="013a - Solicitud Anatomia Patologica">
              {{ idsFormsExistentes.includes('13a') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('13a')" variant="warning" size="sm" class="ml-2"
              @click="generar13a">
              Descargar
            </b-button>
          </div> -->

          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">017 - Protocolo Quirúgico</span>

            <b-button v-if="canViewBtn(codigoProceso, '017')" id="boton-modal017"
              :variant="idsFormsExistentes.includes('017') ? 'success' : 'primary'" size="sm" @click="showModal017"
              title="017 - Protocolo Quirúrgico">
              {{ idsFormsExistentes.includes('017') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('017')" variant="warning" size="sm" class="ml-2"
              @click="generar017">
              Descargar
            </b-button>
          </div>

          <!-- <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">018 - Pre Anestesico</span>

            <b-button v-if="canViewBtn(codigoProceso, '018_')" id="boton-modal018_"
              :variant="idsFormsExistentes.includes('018_') ? 'success' : 'primary'" size="sm" @click="showModalForm18_"
              title="018 - Formulario 018 pre anestesico">
              {{ idsFormsExistentes.includes('018_') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('018_')" variant="warning" size="sm" class="ml-2"
              @click="generar018">
              Descargar
            </b-button>
          </div> -->

          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">Informe Tecnico</span>

            <b-button v-if="canViewBtn(codigoProceso, 'inf')" id="boton-modalinf"
              :variant="idsFormsExistentes.includes('inf') ? 'success' : 'primary'" size="sm" @click="showModalFormInf"
              title="Informe Tecnico">
              {{ idsFormsExistentes.includes('inf') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('inf')" variant="warning" size="sm" class="ml-2"
              @click="generarInformeTecnico">
              Descargar
            </b-button>
          </div>




          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">018A - Cargar form 018A</span>

            <b-button v-if="canViewBtn(codigoProceso, '018')" id="boton-modal018"
              :variant="idsFormsExistentes.includes('018') ? 'success' : 'primary'" size="sm" @click="showModalForm18"
              title="018A - Formulario 018A">
              {{ idsFormsExistentes.includes('018') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('018')" variant="warning" size="sm" class="ml-2"
              @click="generar018">
              Descargar
            </b-button>
          </div>


          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">020 - Constantes Vitales/Balance Hidrico</span>


            <b-button v-if="canViewBtn(codigoProceso, '020')" id="boton-modal020"
              :variant="idsFormsExistentes.includes('020') ? 'success' : 'primary'" size="sm"
              @click="onShowModalForm020" title="020 - Constantes Vitales/Balance Hidrico">
              {{ idsFormsExistentes.includes('020') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('020')" variant="warning" size="sm" class="ml-2"
              @click="generar020">
              Descargar
            </b-button>
          </div>


          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">022 - Administracion de medicamentos</span>

            <b-button v-if="canViewBtn(codigoProceso, '022')" id="boton-modal022"
              :variant="idsFormsExistentes.includes('022') ? 'success' : 'primary'" size="sm" @click="showModalForm022"
              title="022 - Administracion de medicamentos">
              {{ idsFormsExistentes.includes('022') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('022')" variant="warning" size="sm" class="ml-2"
              @click="generar022">
              Descargar
            </b-button>



          </div>


          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">024 - Consentimiento Informado</span>

            <b-button v-if="canViewBtn(codigoProceso, '024')" id="boton-modal024"
              :variant="idsFormsExistentes.includes('024') ? 'success' : 'primary'" size="sm" @click="modalForm024"
              title="024 - Consentimiento Informado">
              {{ idsFormsExistentes.includes('024') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('024')" variant="warning" size="sm" class="ml-2"
              @click="generar024">
              Descargar
            </b-button>


          </div>


          <div class="row ml-2 mb-2 align-items-center">

            <span class="col-6">060 - Llenar formulario cirugia segura</span>

            <b-button v-if="canViewBtn(codigoProceso, '060')" id="boton-modal060"
              :variant="idsFormsExistentes.includes('060') ? 'success' : 'primary'" size="sm" @click="showModal060"
              title="060 - Llenar formulario cirugia segura">
              {{ idsFormsExistentes.includes('060') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('060')" variant="warning" size="sm" class="ml-2"
              @click="generar060">
              Descargar
            </b-button>

          </div>




          <div class="row ml-2 mb-2 align-items-center">

            <span class="col-6">FRC - Formulario Riesgo Caidas</span>

            <b-button v-if="canViewBtn(codigoProceso, 'rc')" id="boton-modalrc"
              :variant="idsFormsExistentes.includes('rc') ? 'success' : 'primary'" size="sm"
              @click="showModalFormRiesgos" title="Llenar riesgo caidas">
              {{ idsFormsExistentes.includes('rc') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('rc')" variant="warning" size="sm" class="ml-2"
              @click="generarRiesgoCaidas">
              Descargar
            </b-button>

          </div>



          <div class="row ml-2 mb-2 align-items-center">
            <span class="col-6">CLD - Check list documental</span>


            <b-button v-if="canViewBtn(codigoProceso, 'cld')" id="boton-modalcld"
              :variant="idsFormsExistentes.includes('cld') ? 'success' : 'primary'" size="sm" @click="showModalCLD"
              title="CLD - Check List Documental">
              {{ idsFormsExistentes.includes('cld') ? 'Actualizar' : 'Procesar' }}

            </b-button>

            <b-button v-if="idsFormsExistentes.includes('cld')" variant="warning" size="sm" class="ml-2"
              @click="generarCheckList">
              Descargar
            </b-button>


          </div>

          <!-- <div class="row ml-2 mb-2 align-items-center">
            <b-button @click="openDicon"></b-button> 


          </div>


          <div class="row ml-2 mb-2 align-items-center">
          <span class="col-6">Formulario 020 Propuesta</span>

          <b-button variant="primary" size="sm" class="" @click="navigateToQuery('propuesta020', tokenFormulario)">
            Procesar
          </b-button>
        </div>


        <div class="row ml-2 mb-2 align-items-center">
          <span class="col-6">Formulario 018 Propuesta</span>

          <b-button variant="primary" size="sm" class="" @click="navigateToQuery('f018b', tokenFormulario)">
            Procesar
          </b-button>
        </div> -->

        </div>
      </b-card>
    </b-overlay>

    <Formulario022 v-if="show022" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <Formulario006 v-if="show006" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <Formulario012B v-if="show012b" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />
    <Formulario012BNormal v-if="show012bNormal" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <!-- <Formulario013a   v-if="show013a"@formulario-guardado="refreshFormularios" :tokenAtencion="tokenAtencion" /> -->

    <Formulario018 v-if="show018" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <FormCld v-if="showcld" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <Formulario005 v-if="show005" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <Formulario020 v-if="show020" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <Formulario024 v-if="show024" @formulario-guardado="refreshFormularios" />

    <Formulario060 v-if="show060" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <Formulario003 v-if="show003" @formulario-guardado="refreshFormularios" :tokenAtencion="tokenAtencion"
      :dataProceso="dataProc" />


    <Formulario017 v-if="show017" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <RiesgoCaidas v-if="showrc" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <FormularioInformeTecnico v-if="showinf" @formulario-guardado="refreshFormularios" :dataProceso="dataProc" />

    <Formulario020B v-if="show020b" />
    <Formulario018B v-if="show018b" />
    <!--   <b-modal id="modal-dycom" size="xl">
     <DicomView/> 
    </b-modal>
  -->

  </ModalContainer>
</template>

<script>
import { ModalContainer } from "@/shared/components";
import Formulario003 from "./Formularios/Formulario003.vue";
import Formulario005 from "./Formularios/Formulario005.vue";
import Formulario060 from "./Formularios/Formulario060.vue";
import Formulario024 from "./Formularios/Formulario024.vue";
import Formulario022 from "./Formularios/Formulario022.vue";
import Formulario020 from "./Formularios/Formulario020.vue";
import Formulario012B from "./Formularios/Formulario012B.vue";
import Formulario006 from "./Formularios/Formulario006.vue";
import Formulario013a from "./Formularios/Formulario013a.vue";
import Formulario018 from "./Formularios/Formulario018.vue";
import FormCld from "./Formularios/FormCld.vue";
import RiesgoCaidas from "./Formularios/RiesgoCaidas.vue";

import Formulario020B from "./Formularios/Formulario020B.vue";
import Formulario018B from "./Formularios/Formulario018B.vue";
import { procedimientosFormulariosService } from "../services";
import actions from "@/assets/utils/utils"
import Formulario017 from "./Formularios/Formulario017.vue";
import FormularioInformeTecnico from "./Formularios/FormularioInformeTecnico.vue";
import Formulario012BNormal from "./Formularios/Formulario012BNormal.vue";
//import DicomView from "./dycom/DicomView.vue";

export default {

  components: {
    ModalContainer,
    Formulario003,
    Formulario005,
    Formulario060,
    Formulario024,
    Formulario022,
    Formulario020,
    Formulario012B,
    Formulario006,
    Formulario013a,
    Formulario018,
    FormCld,
    RiesgoCaidas,
    Formulario012BNormal,

    Formulario020B,
    Formulario018B,
    Formulario017,
    FormularioInformeTecnico,
    //DicomView
  },


  data() {
    return {

      formsExistentes: null,
      tokenAtencion: null,
      codigoProceso: "57460",
      //tokenProceso: "0a2f9e95-1f86-4310-bc37-9478e08182f1"
      tokenFormulario: "x",
      tokenProceso: '',
      formulariosExistentes: [],
      idsFormsExistentes: [],
      idProceso: null,
      cargandoFormularios: false,
      processing: false,
      busy: false,
      counter: 1,

      show003: false,
      show005: false,
      show006: false,
      show013a: false,
      show012b: false,
      show012bNormal: false,
      show017: false,
      show018: false,
      show018b: false,
      show020: false,
      show020b: false,
      show022: false,
      show060: false,
      showrc: false,
      showinf: false,
      showcld: false,
      show024: false



    };
  },


  props: {
    tokenProceso: {
      default: null,
      required: true
    },
    dataProc: {
      default: null,
      required: false
    }
  },

  watch: {



    '$route.query.forms': {
      handler(newValue) {
        if (!newValue) {
          this.show003 = false,
            this.show005 = false,
            this.show006 = false,
            this.show013a = false,
            this.show012b = false,
            this.show012bNormal = false,
            this.show017 = false,
            this.show018 = false,
            this.show018b = false,
            this.show020 = false,
            this.show020b = false,
            this.show022 = false,
            this.show060 = false,
            this.showrc = false,
            this.showinf = false,
            this.showcld = false,
            this.show024 = false
        }

      }
    },



    tokenProceso: {
      deep: true,
      immediate: true,
      async handler(newVal) {
        if (newVal) {

          this.formsExistentes = {
            f003: 'x',
            f005: 'x',
            f012b: 'x',
            f012bNormal: 'x',
            f006: 'x',
            f013: 'x',
            f017: 'x',
            f018: 'x',
            f020: 'x',
            f022: 'x',
            f024: 'x',
            f060: 'x',
            frc: 'x',
            fcld: 'x',
            finf: 'x'

          }

          this.cargandoFormularios = true
          this.busy = true
          const response = await procedimientosFormulariosService.getByProceso(newVal);

          this.formulariosExistentes = response?.data



          this.formulariosExistentes.forEach(item => {
            if (item.idFormulario === '12b') {
              this.formsExistentes.f012b = item.token
            }
            if (item.idFormulario === '003') {
              this.formsExistentes.f003 = item.token
            }
            if (item.idFormulario === '005') {
              this.formsExistentes.f005 = item.token
            }
            if (item.idFormulario === '006') {
              this.formsExistentes.f006 = item.token
            }
            if (item.idFormulario === '13a') {
              this.formsExistentes.f013 = item.token
            }
            if (item.idFormulario === '018') {
              this.formsExistentes.f018 = item.token
            }
            if (item.idFormulario === '020') {
              this.formsExistentes.f020 = item.token
            }
            if (item.idFormulario === '022') {
              this.formsExistentes.f022 = item.token
            }
            if (item.idFormulario === '024') {
              this.formsExistentes.f024 = item.token
            }
            if (item.idFormulario === '060') {
              this.formsExistentes.f060 = item.token
            }
            if (item.idFormulario === 'rc') {
              this.formsExistentes.frc = item.token
            }
            if (item.idFormulario === 'cld') {
              this.formsExistentes.fcld = item.token
            }
            if (item.idFormulario === '017') {
              this.formsExistentes.f017 = item.token
            }
            if (item.idFormulario === 'inf') {
              this.formsExistentes.finf = item.token
            }
            if (item.idFormulario === '12bNormal') {
              this.formsExistentes.f012bNormal = item.token
            }

          })

          console.log("estos son los formularios existentes", this.formsExistentes)
          this.tokenAtencion = response?.tokenAtencion
          this.idProceso = response?.idProceso
          this.identificacion = response?.identificacion
          this.cargandoFormularios = false
          this.busy = false

        }
      }
    },
    formulariosExistentes: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length) {
          let idsFormsExistentes = []
          newValue.forEach(element => {
            idsFormsExistentes.push(element.idFormulario)

          });
          this.idsFormsExistentes = idsFormsExistentes

          console.log("ids formularios", this.idsFormsExistentes)
        } else {
          this.idsFormsExistentes = []
        }
      }
    },

  },


  methods: {

    // openDicon(){
    //   this.$bvModal.show('modal-dycom')
    // },
    async descargarZipInformes() {
      this.processing = true;
      this.busy = true;
      this.counter = 1;

      // Iniciar un timer que aumente el counter cada 300ms
      const interval = setInterval(() => {
        if (this.counter < 19) {
          this.counter++;
        }
      }, 300);

      // Esperar la descarga
      const arregloRespuesta = await procedimientosFormulariosService.descargarZipInformes(this.idProceso);

      // Detener el timer
      clearInterval(interval);

      // Si hay respuesta, generar el archivo
      if (arregloRespuesta) {
        console.log("entra a descargar carpeta de formularios");
        let nombreArchivo = `${this.identificacion}-formularios`;
        actions.generateZipInformes(arregloRespuesta, nombreArchivo);
      }

      this.counter = 20;
      this.processing = false;
      this.busy = false;
    },




    canViewBtn(codigo, nameButton) {
      // return (dataForms[codigo]) 
      //   ? dataForms[codigo].includes(nameButton)
      //   : false;

      return true
    },

    async showModal003() {
      this.show003 = true
      this.navigateToQuery("f003", this.formsExistentes.f003);
    },


    async showModal13a() {
      this.show013a = true
      this.navigateToQuery("13a", this.formsExistentes.f013);
    },


    showModalForm18() {
      this.show018 = true
      this.navigateToQuery("f018", this.formsExistentes.f018);
    },

    showModal017() {
      this.show017 = true
      this.navigateToQuery("f017", this.formsExistentes.f017);
    },


    showModalFormRiesgos() {
      this.showrc = true
      this.navigateToQuery("rc", this.formsExistentes.frc);
    },

    async showModalForm006() {
      this.show006 = true
      this.navigateToQuery("f006", this.formsExistentes.f006);
    },

    async showModalForm053(token) {
      this.navigateToQuery("f053", token);
    },

    async modalForm024() {
      this.show024 = true
      this.navigateToQuery("f024", this.formsExistentes.f024);
    },


    async showModalForm005() {
      this.show005 = true
      this.navigateToQuery("f005", this.formsExistentes.f005);
    },

    async showModalForm022() {
      this.show022 = true
      this.navigateToQuery("f022", this.formsExistentes.f022);
    },

    async onShowModalForm020() {
      this.show020 = true
      this.navigateToQuery("f020", this.formsExistentes.f020);
    },


    async showModal060() {
      this.show060 = true
      this.navigateToQuery("f060", this.formsExistentes.f060);
    },

    async showModalFormInf() {
      this.showinf = true
      this.navigateToQuery("finf", this.formsExistentes.finf);
    },


    async showModalCLD() {
      this.showcld = true
      this.navigateToQuery("cld", this.formsExistentes.fcld);
    },


    async descargarArchivoPdf(pdfBlob, nombreArchivo) {
      try {

        if (!pdfBlob) {
          throw new Error("No se recibió el PDF en base64.");
        }

        // Convertir base64 a Blob
        const byteCharacters = atob(pdfBlob);
        const byteNumbers = Array.from(byteCharacters).map(c => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        // Crear enlace de descarga
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${nombreArchivo}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

      } catch (error) {
        console.error("Error al generar el PDF:", error);
        this.$swal("Error", "No se pudo generar el informe", "error");
      }
    },

    async generar12b() {
      const pdfBlob = await procedimientosFormulariosService.generar12bProc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-12B`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },

    async generar12bNormal() {
      const pdfBlob = await procedimientosFormulariosService.generar12bNormalProc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-12B`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },

    async generar003() {
      const pdfBlob = await procedimientosFormulariosService.generar003Proc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-003`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },

    async generar005() {
      const pdfBlob = await procedimientosFormulariosService.generar005Proc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-005`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },

    async generar006() {
      const pdfBlob = await procedimientosFormulariosService.generar006Proc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-006`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },

    async generar13a() {
      const pdfBlob = await procedimientosFormulariosService.generar13aProc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-13a`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },
    async generar018() {
      const pdfBlob = await procedimientosFormulariosService.generar018Proc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-18a`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },
    async generar017() {
      const pdfBlob = await procedimientosFormulariosService.generar017Proc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-017`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },
    async generar020() {
      const pdfBlob = await procedimientosFormulariosService.generar020Proc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-020`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },
    async generar022() {
      const pdfBlob = await procedimientosFormulariosService.generar022Proc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-022`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },
    async generar024() {
      const pdfBlob = await procedimientosFormulariosService.generar024Proc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-024`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },

    async generar060() {
      const pdfBlob = await procedimientosFormulariosService.generar060Proc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-formulario-060`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },

    async generarRiesgoCaidas() {
      const pdfBlob = await procedimientosFormulariosService.generarRiesgoCaidasProc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-riesgo-caidas`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },
    async generarInformeTecnico() {
      const pdfBlob = await procedimientosFormulariosService.generarInformeTecnico(this.idProceso)
      let nombreArchivo = `${this.identificacion}-informe-tecnico`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },

    async refreshFormularios() {
      this.cargandoFormularios = true
      this.busy = true
      const response = await procedimientosFormulariosService.getByProceso(this.tokenProceso);

      this.formulariosExistentes = response?.data || [];

      const nuevosTokens = {
        f003: 'x', f005: 'x', f006: 'x', f012b: 'x', f013: 'x', f017: 'x',
        f018: 'x', f020: 'x', f022: 'x', f024: 'x', f060: 'x', frc: 'x',
        fcld: 'x', finf: 'x', f12bNormal: 'x'
      };

      this.formulariosExistentes.forEach(item => {
        const map = {
          '003': 'f003', '005': 'f005', '006': 'f006', '12b': 'f012b', '13a': 'f013',
          '017': 'f017', '018': 'f018', '020': 'f020', '022': 'f022', '024': 'f024',
          '060': 'f060', 'rc': 'frc', 'cld': 'fcld', 'inf': 'finf', '12bNormal': 'f012bNormal'
        };
        if (map[item.idFormulario]) {
          nuevosTokens[map[item.idFormulario]] = item.token;
        }
      });

      this.formsExistentes = nuevosTokens;
      this.idsFormsExistentes = this.formulariosExistentes.map(f => f.idFormulario);
      this.cargandoFormularios = false
      this.busy = false
    },



    async generarCheckList() {
      const pdfBlob = await procedimientosFormulariosService.generarCheckListProc(this.idProceso)
      let nombreArchivo = `${this.identificacion}-check-list`
      await this.descargarArchivoPdf(pdfBlob, nombreArchivo)
    },


    async modalForm012B() {
      this.show012b = true
      this.navigateToQuery("f012", this.formsExistentes.f012b);

    },
    async modalForm012BNormal() {
      this.show012bNormal = true
      this.navigateToQuery("f012Normal", this.formsExistentes.f012bNormal);

    },





    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },



  }
}
</script>
